export default "__VITE_ASSET__BP6UDy95__"